import { useMemo } from 'react'
import differenceInDays from 'date-fns/differenceInDays'
import { ILead } from '@user/store/lead'
import { currencyString } from '@sales-center/common'
import { BulkActionsProps } from '@user/components/xGrid'

export const useBulkActionLabels = (
  selectedRows: BulkActionsProps['selectedRows'],
) => {
  const [avgAge, totalValue] = useMemo(() => {
    const rows = [...selectedRows.entries()]
    const today = new Date()

    const { totalAge, totalValue } = rows.reduce(
      ({ totalAge, totalValue }, [, row]) => {
        const lead = row as ILead
        return {
          totalAge:
            totalAge + differenceInDays(today, new Date(lead.createdDate)),
          totalValue: totalValue + lead.totalLeadValue,
        }
      },
      { totalAge: 0, totalValue: 0 },
    )

    const avgAge = Math.floor(totalAge / rows.length)

    return [
      `Average Age: ${avgAge} ${avgAge === 1 ? 'day' : 'days'}`,
      `Total Value: $${currencyString(totalValue)}`,
    ]
  }, [selectedRows])

  return { avgAge, totalValue }
}
